import React, { useState } from "react";
import { Card, CardBody, CardTitle, Row, Col, Collapse } from "reactstrap";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";

const ImageList = ({ images }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);
  
  const toggleAccordion = () => {
    setIsAccordionOpen((prev) => !prev);
  };
  
  return (
    <>
      <Card
        className="shadow-sm border-0 overflow-hidden mb-4"
        style={{ borderRadius: "12px" }}
      >
        <div
          className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
          style={{
            background: "#555B21",
            letterSpacing: "0.5px",
            cursor: "pointer",
            userSelect: "none",
          }}
          onClick={toggleAccordion}
        >
          <div className="d-flex align-items-center">
            <span style={{ fontSize: "0.82rem" }}>Images</span>
          </div>
          <span style={{ fontSize: "16px", fontWeight: "bold" }}>
            {isAccordionOpen ? (
              <FiChevronUp size={16} />
            ) : (
              <FiChevronDown size={16} />
            )}
          </span>
        </div>
        <Collapse isOpen={isAccordionOpen}>
          <CardBody>
          <Row>
            {Object.entries(images).map(([key, imageUrl], index) => (
              <Col sm="6" key={index}>
                <p className="mb-2">
                  <i style={{ color: "#9d9c9c" }}>
                    <span
                      style={{
                        display: "inline-block",
                        width: "6em",
                        whiteSpace: "nowrap",
                        fontSize: "15px",
                      }}
                    >
                      {key} :
                    </span>
                  </i>
                  {imageUrl && imageUrl != null ? (
                    <a href={imageUrl} download>
                      {" "}
                      <i
                        style={{ fontSize: "20px" }}
                        className="bx bx-download"
                      ></i>
                    </a>
                  ) : (
                    <span></span>
                  )}
                </p>
              </Col>
            ))}
          </Row>
        </CardBody>
        </Collapse>
      </Card>
    </>
  );
};

export default ImageList;
